import React, { type RefObject } from 'react';
import { ProjectCard } from './ProjectCard';
import { projectRows, type Project } from '../data/projects';

/** Width / offset per size — percentages of the content width, measured from the reference at 1280px */
const SIZE_CLASS: Record<Project['size'], string> = {
  large: 'md:w-[49.5%]',
  small: 'md:w-[32.6%] md:mt-[9vw]',
  wide: 'md:w-[66.3%]'
};

/** Wide visuals hug the right edge unless the project asks for the left, so wide rows can alternate */
function sizeClass(project: Project): string {
  if (project.size !== 'wide') return SIZE_CLASS[project.size];
  return `${SIZE_CLASS.wide} ${project.align === 'left' ? '' : 'md:ml-auto'}`;
}

/** Position of a project in reading order across all rows */
function flatIndex(row: number, col: number): number {
  return projectRows.slice(0, row).reduce((n, r) => n + r.length, 0) + col;
}

/**
 * Staggered editorial project grid in light mode: a large visual and a smaller dropped one share a row,
 * a wide indented one gets its own row.
 */
interface ProjectsSectionProps {
  /** The project grid itself — its bottom edge ends dark mode */
  gridRef?: RefObject<HTMLDivElement>;
}
export function ProjectsSection({
  gridRef
}: ProjectsSectionProps) {
  return <section id="work" aria-label="Work" className="relative w-full px-3 text-black" data-id="element-196" data-mp="30wjaxll74adu">

      {/* Generous row gaps — also leave room for the parallax drift so rows never crowd each other */}
      {/* Phones: one even 96px gap between every project, within and across rows */}
      <div ref={gridRef} className="flex flex-col gap-24 md:gap-[clamp(7rem,16vw,18rem)]" data-id="element-197" data-mp="2m8og9znmnvy4">
        {projectRows.map((row, r) => <div key={r} className="flex flex-col gap-24 md:flex-row md:items-start md:justify-between md:gap-0" data-id="element-198" data-mp="2h8ae2y8pjg80" data-mpi={r}>
            {row.map((project, c) => <ProjectCard key={project.client} project={project}
        // Quest: shard four hides behind one of the visuals
        questSpot={`project-${flatIndex(r, c)}`} className={`w-full ${sizeClass(project)}`} data-id="element-199" data-mp="288ng6mf6ssjp" data-mpi={c} />)}
          </div>)}
      </div>
    </section>;
}